import axios, { AxiosResponse } from "axios";
import { appAxios } from "bootstrap";

const memberMemo = (): void => {
    document
        .querySelectorAll<HTMLButtonElement>(".js-memo-save-button")
        .forEach((button) => {
            button.addEventListener("click", async () => {
                const container =
                    button.closest<HTMLTableRowElement>(".js-memo-container");

                if (!container) return;

                const memberId = container.dataset.memberId;
                const field = container.querySelector<
                    HTMLTextAreaElement | HTMLInputElement
                >(".js-memo-field");

                if (!memberId || !field) return;

                try {
                    const response: AxiosResponse = await appAxios.patch(
                        `/admin/api/members/${memberId}/memo`,
                        { memo: field.value }
                    );

                    if (response.status !== 200) {
                        throw new Error("Unexpected response");
                    }

                    button.textContent = "保存中";
                    button.disabled = true;

                    setTimeout(() => {
                        button.textContent = "保存";
                        button.disabled = false;
                        alert("メモの保存が完了しました。");
                    }, 1000);
                } catch (error) {
                    if (axios.isAxiosError(error)) {
                        if (error.response?.status === 422) {
                            alert("入力内容に問題があります");
                            return;
                        }
                    }

                    alert("メモの保存に失敗しました");
                }
            });
        });
};

export default memberMemo;
